import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { I18nextProvider } from 'react-i18next';
import LeadsStoreProvider from '@panel/leads/src/stores/main/storeContext';
import { ThemeProvider } from 'styled-components';
import StyleSetup, { Theme } from '@panel/commons/core';
import dotenv from 'dotenv';
import { SnackbarProvider } from '@panel/commons/lib/snackbar';
import { LoaderProvider } from '@panel/commons/lib/Loader';
import Themev2 from '@panel/commons/lib/theme';
import { getThemeREUIKITBySite } from '@panel/commons/helpers/getThemeREUIKITBySite';
import App from './App';
import { configureStore, history } from './state';
import i18n from './i18n/i18n';

dotenv.config();

const store = configureStore(history);

const app = (
  <ReduxProvider store={store}>
    <ConnectedRouter history={history}>
      <SnackbarProvider>
        <LoaderProvider>
          <I18nextProvider i18n={i18n}>
            <ThemeProvider theme={{ ...getThemeREUIKITBySite(), ...Theme, ...{ v2: Themev2 } }}>
              <LeadsStoreProvider>
                <StyleSetup />
                <App history={history} />
              </LeadsStoreProvider>
            </ThemeProvider>
          </I18nextProvider>
        </LoaderProvider>
      </SnackbarProvider>
    </ConnectedRouter>
  </ReduxProvider>
);

const domNode = document.getElementById('root');
const root = createRoot(domNode);

root.render(app);
